import { useEffect } from 'react';

/**
 * Sends the visitor to a page on another site, replacing this history entry.
 * The old in-app /terms and /privacy pages now live on the landing site; their
 * paths stay so links already sent out keep working.
 */
const ExternalRedirect: React.FC<{ to: string }> = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};

export default ExternalRedirect;
